Namespace 'Customer.Ticket'

class Customer.Ticket.TicketStatusView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/ticket_status']
  className: 'ticket-status'

  initialize: ({ticket}) ->
    @ticket = ticket

  render: ->
    @$el.html @template
      assignedIcon: @assignedIcon()
      currentStatus: @currentStatus()
      detailsName: @detailsName()
      detailsStatus: @getTranslationFor(@ticket.get('status'))
      statusIcon: @statusIcons()[@currentStatus()]
    @

  assignedIcon: ->
    hasGroup = @ticket.get('users_group_id')
    isAssigned = @ticket.get('assigned_to_id')

    if isAssigned
      'keepcon-custom-icons assigned-icon'
    else if hasGroup
      'keepcon-custom-icons group-assignment-icon'
    else
      'keepcon-custom-icons unassigned-icon'

  currentStatus: ->
    _.string.slugify(@ticket.get('status'))

  statusIcons: ->
    {
      'assigned': 'fa fa-check-circle',
      'closed': 'fa fa-check-circle',
      'not-assigned': 'fa fa-times-circle',
      'pending': 'fa fa-clock-o',
      'reopen': 'fa fa-refresh'
    }

  detailsName: ->
    if @ticket.get('chatbot_code')? then @_chatbotDetailsName() else @ticket.get('assigned_to_name')

  _chatbotDetailsName: ->
    'Chatbot' + @ticket.get('chatbot_code')

  getTranslationFor: (status) ->
    I18n.t('customer.dashboard.conversations.status.' + status.toLowerCase().replace(' ', '_'))
